module.exports = __webpack_public_path__ + "static/media/video.7b059cad.jpg";